import styled from "styled-components";

export default styled.div`
  display: flex;
  flex: auto;
  width: 100%;
  height: 75%;
`;



// WEBPACK FOOTER //
// ./src/components/common/Fullscreen.js